import { ButtonGroup, Flex, Text } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { COMMON_MESSAGES } from "../../../common-messages";
import { AIR_MESSAGES } from "../../message-definitions";
import type { ReconnectionStep } from "../util";

interface CannotReconnectBankProps {
  setCurrentReconnectStep: (step: ReconnectionStep) => void;
}

export const CannotReconnectBank = ({ setCurrentReconnectStep }: CannotReconnectBankProps) => {
  const intl = useIntl();
  return (
    <Flex direction="column" gap="4">
      <Text>
        {intl.formatMessage({
          id: "funding-application: air reconnect connection cannot reconnect bank",
          defaultMessage:
            "If you're having issues reconnecting your bank, you will need to upload your bank statements to continue.",
        })}
      </Text>
      <ButtonGroup
        primaryAction={{
          onAction: () => setCurrentReconnectStep("upload_bank_statements"),
          content: intl.formatMessage(AIR_MESSAGES.bankStatementBankStatementsText),
          analyticsId: "reconnect-connection-trigger-bank-statements-button",
        }}
        secondaryAction={{
          onAction: () => setCurrentReconnectStep("reconnect_connection_landing"),
          content: intl.formatMessage(COMMON_MESSAGES.backLabel),
          analyticsId: "reconnect-connection-bank-cannot-connect-back-button",
        }}
        primaryActionTestId="navigation-continue-button"
        secondaryActionTestId="navigation-back-button"
      />
    </Flex>
  );
};
